module.exports = __webpack_public_path__ + "static/img/11bg_4.f2618a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_4.png
// module id = 632
// module chunks = 1